<template>
    <v-col cols="12" sm="6" md="6" lg="8" xl="8">
        <ConfirmDialog
            :is-open="saveUserTaskDialog"
            :data="userTask"
            :action-loading="actionLoading"
            @on-confirm="saveUserTask(userTask)"
            @on-abort="closeSaveUserTaskDialog"
        >
            <template #content>
                Czy na pewno chcesz zakończyć zadanie?
            </template>
            <template #confirmButton>
                Potwierdź
            </template>
        </ConfirmDialog>
        <UserTaskDialog
            :is-open="userTaskDialog"
            :user-task-data="userTask"
            action-name="Szczegóły zadania"
            action="openUserTask"
            @on-close="closeUserTaskDialog"
        />
        <v-card>
            <v-toolbar flat dense color="grey lighten-4">
                <v-toolbar-title>
                    {{ widget.body.title }}
                </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :loading="userTasksLoading"
                    :items="userTasks"
                    dense
                    height="150"
                    :footer-props="footerProps"
                    :server-items-length="pagination.itemsLength"
                    :mobile-breakpoint="0"
                    name="userTasksData"
                    @pagination="updatePagination"
                >
                    <template #item="{item}">
                        <tr>
                            <td>
                                {{ item.title }}
                            </td>
                            <td>
                                {{ formatDate(item.plannedFinishDate, withTime = false) }}
                            </td>
                            <td class="text-center">
                                <div class="d-inline-flex">
                                    <v-tooltip :open-delay="tooltipDelay" top>
                                        <template #activator="{on}">
                                            <v-btn
                                                icon
                                                data-sentry-label="Otwórz potwierdzenie zadania"
                                                v-on="on"
                                                @click="showSaveUserTask(item.id)"
                                            >
                                                <v-icon color="success">
                                                    mdi-check
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Zakończ zadanie</span>
                                    </v-tooltip>
                                    <v-tooltip :open-delay="tooltipDelay" top>
                                        <template #activator="{on}">
                                            <v-btn
                                                icon
                                                data-sentry-label="Szczegóły zadania"
                                                v-on="on"
                                                @click="showOpenTask(item.id)"
                                            >
                                                <v-icon color="blue">
                                                    mdi-ballot
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Szczegóły zadania</span>
                                    </v-tooltip>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import { errorHandler } from '@/utils/errorHandler'
import UserTaskDialog from '@/views/UserTasks/UserTasks/UserTaskDialog'
import { EventBus } from '@/utils/eventBus'

export default {
    name: 'UserTasksList',
    components: {
        ConfirmDialog, UserTaskDialog
    },
    mixins: [
        dateFormatter,
        pagination,
        tooltipDelay
    ],
    props: {
        widget: {
            type: Object,
            default: null
        },
        permissions: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            userTask: {},
            userTaskDialog: false,
            actionLoading: false,
            saveUserTaskDialog: false,
            headers: [
                {
                    text: 'Temat',
                    value: 'title',
                    sortable: false,
                },
                {
                    text: 'Data ukończenia',
                    value: 'plannedFinishDate',
                    sortable: false,
                    width: 150
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ],
        }
    },
    computed: {
        userTasks() {
            return this.$store.state.dashboard.dashboard.userTasks
        },
        userTasksLoading() {
            return this.$store.state.dashboard.dashboard.userTasksLoading
        },
    },
    mounted() {
        this.$store.dispatch('userTasks/getUserTaskStatuses')
            .catch(error => {
                errorHandler(error)
            })
    },
    methods: {
        async getUserTask(userTaskId) {
            return await this.$store.dispatch('userTasks/getUserTask', userTaskId)
                .then(response => {
                    this.userTask = response.data
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showSaveUserTask(userTaskId) {
            this.getUserTask(userTaskId)
                .then(()=> {
                    this.saveUserTaskDialog = true
                })
        },
        closeSaveUserTaskDialog() {
            this.saveUserTaskDialog = false
            setTimeout(() => {
                this.userTask = {}
            }, 500)
        },
        showOpenTask(userTaskId) {
            this.getUserTask(userTaskId)
                .then(() => {
                    this.userTaskDialog = true
                })
        },
        closeUserTaskDialog() {
            this.userTaskDialog = false
            setTimeout(() => {
                this.userTask = {}
            }, 500)
        },
        saveUserTask() {
            this.actionLoading = true
            this.userTask.userTaskStatusId = 20 //Done
            this.userTask.finishDate = new Date().toISOString()
            this.$store.dispatch('userTasks/updateUserTask', this.userTask)
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    EventBus.$emit('getUserTasks')
                    this.actionLoading = false
                    this.closeSaveUserTaskDialog()
                    this.getDashboard()
                })
        },
        getDashboard() {
            this.$store.dispatch('dashboard/getDashboardItem', {
                item: this.widget,
                paginate: this.paginate(),
                query: ''
            })
                .then(response => {
                    this.handlePaginationResponse(response.data.body)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getDashboard()
            }
            this.clearPaginationPending()
        }
    }
}
</script>
